import FilterAssigneeList from './filterAssigneeList';

const groupedAssignees = (userList) => FilterAssigneeList(userList).map((data) => ({ ...data }));

export default groupedAssignees;